import AccessDetail from "@components/Accesses/AccessDetails/screens/Details";

export default AccessDetail;
